import { gql } from '@apollo/client'

const userError = gql`
  fragment userError on UserError {
    message
    code
  }
`

export default userError
